export function resolveQuizFailure(err) {
  const response = err && err.response;
  const detail = response && response.data && response.data.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return { message: detail.trim(), loadBackup: false, kind: 'blocked' };
  }

  if (response) {
    return {
      message: 'The AI quiz service is unavailable right now. Loading offline backup benchmark...',
      loadBackup: true,
      kind: 'server',
    };
  }

  return {
    message: 'Could not reach the AI quiz service. Loading offline backup benchmark...',
    loadBackup: true,
    kind: 'network',
  };
}
